import AccountSetupModal from './AccountSetupModal';

export default AccountSetupModal;
